function init_soccer() {
    var index = _moduleTimeHandler.getNewIndex(),main = $(".place.soccerwelcome"),lvl1 = main.find(".menu").eq(0);

    if(!lvl1.hasClass("completed")) {
        _moduleTimeHandler.set(index, function () {
            if(lvl1.hasClass("blink")) {
                lvl1.removeClass("blink");
            } else {
                lvl1.addClass("blink");
            }
        }, 800);
    }
}